import { AlertTriangle, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

interface InvalidPositIdErrorProps {
  positId: string;
  showDetails?: boolean;
}

const InvalidPositIdError: React.FC<InvalidPositIdErrorProps> = ({ 
  positId, 
  showDetails = false 
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[400px] p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 bg-destructive/10 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-destructive" />
          </div>
          <CardTitle className="text-lg">Invalid Posit ID</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground text-sm">
            The posit ID in the URL appears to be invalid. This usually happens when:
          </p>
          <ul className="text-left text-sm text-muted-foreground space-y-1">
            <li>• The URL was manually typed incorrectly</li>
            <li>• A title was used instead of the proper ID</li>
            <li>• The posit may have been deleted</li>
          </ul>
          
          {showDetails && (
            <div className="mt-4 p-3 bg-muted rounded-md">
              <p className="text-xs font-mono break-all">
                Invalid ID: {positId}
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Expected format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
              </p>
            </div>
          )}
          
          <div className="space-y-2">
            <Button 
              onClick={() => navigate('/dashboard')}
              className="w-full"
            >
              <Home className="w-4 h-4 mr-2" />
              Go to Dashboard
            </Button>
            <Button 
              variant="outline" 
              onClick={() => navigate('/public-posits')}
              className="w-full"
            >
              Browse Public Posits
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default InvalidPositIdError; 